
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#c6060e",
        secondary: "#eeeeee",
        drawer: "#FFFFFF",
        helpeGrey: "#E5E5E5"
      }
    }
  },
  breakpoint: {
    thresholds: {
      lg: 1600
    },
    scrollBarWidth: 16,
  },
});
